import React from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";



const CabinetLeaderboardMain = () => {
    const { t } = useTranslation();
    const leaderboard = useSelector(store => store.cabinet.leaderboard);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.ftfCard}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Таблица лидеров')}</div>
                <div className={Styles.tableWrap}>
                    <div className={Styles.tableNameRow}>
                        <div className={Styles.tableNameRowItem}>{t('Позиция')}</div>
                        <div className={Styles.tableNameRowItem}>{t('Никнейм')}</div>
                        <div className={Styles.tableNameRowItem}>{t('Баланс')}</div>
                    </div>
                    <div className={Styles.tableBox}>
                        {leaderboard ? leaderboard.map((item, index)=>{
                            return (
                                <div className={Styles.tableBoxRow} key={'leaderboard' + index}>
                                    <div className={Styles.tableBoxRowItem}>{index + 1}</div>
                                    <div className={Styles.tableBoxRowItem}>{item.username}</div>
                                    <div className={Styles.tableBoxRowItem}>{item.coins * 1} CFP</div>
                                </div>
                            )
                        }) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetLeaderboardMain;